/*!
 * Copyright 2024 - Swiss Data Science Center (SDSC)
 * A partnership between École Polytechnique Fédérale de Lausanne (EPFL) and
 * Eidgenössische Technische Hochschule Zürich (ETHZ).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { FieldValues } from "react-hook-form";

import type { GenericProjectFormFieldProps } from "./formField.types";
import NameFormField from "./NameFormField";

export default function ProjectNameFormField<T extends FieldValues>({
  control,
  errors,
  formId,
  helpText,
  name,
}: GenericProjectFormFieldProps<T>) {
  return (
    <NameFormField
      control={control}
      entityName={`${formId}-project`}
      errors={errors}
      helpText={helpText}
      name={name}
    />
  );
}
